import { makeStyles } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { TheCycleverseTheme } from "src/theme";
import { CalculatorBodyText } from "../CalculatorTypography";
const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  link: {
    textDecoration: "underline",
    color: theme.openButtonColor,
    cursor: "pointer",
  },

  boldText: {
    fontWeight: 900,
  },

  centerText: {
    textAlign: "center",
  },
}));

const Result2 = ({ Sj, Sm, Fj, Fm, Yj, fields, twentyIsChecked }) => {
  const classes = useStyles();
  const { t } = useTranslation("lebenserwartungsrechner");
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "medium", fontWeight: 900 }}>{t("resultTitle")}</div>
        <div style={{ fontSize: "24px" }}>
          <span>{t("result2Line1")}</span>
          <br />
          <span>{t("result2Line2")}</span>
          <span style={{ color: "#009fe5", fontWeight: "bold" }}>{`${Sj} ${t("years")}`}</span>
          <span> {t("and")} </span>
          <span style={{ color: "#009fe5", fontWeight: "bold" }}>
            {Sm} {t("months")}.
          </span>
        </div>

        {!twentyIsChecked ? (
          <div style={{ fontSize: "24px" }}>
            <span>{t("result2Line3")}</span>
            <span style={{ color: "#009fe5", fontWeight: "bold" }}>
              {Fj} {t("years")}
            </span>
            <span> {t("and")}</span>
            <span style={{ color: "#009fe5", fontWeight: "bold" }}>
              {Fm} {t("months")}
            </span>
            <br />
            <span>{t("result2Line4a")}</span> <span>{t("result2Line4b")}.</span>
          </div>
        ) : null}

        <div style={{ fontSize: "24px", color: "#12A537" }}>
          <span>{t("result2Line5")}</span>
          <br />
          <span>
            <span style={{ fontSize: "40px", fontWeight: 900 }}>{Yj}</span> {t("years")}
          </span>
          <span> {t("and")} </span>
          <span>
            <span style={{ fontSize: "40px", fontWeight: 900, marginRight: "10px" }}>{Sm}</span>
            <span style={{ fontWeight: "bold" }}>{t("months")}.</span>
          </span>
        </div>
      </div>

      {fields?.field18 === "dropdown18Option2" ? (
        <CalculatorBodyText>
          <span className={classes.boldText}>{t("assumption")}</span>
          {Number(fields?.field21a) + Number(fields?.field21b) !== 0 ? <span>{t("paragraph9")}</span> : null}
        </CalculatorBodyText>
      ) : (
        <CalculatorBodyText>
          <span className={classes.boldText}>{t("assumption")}</span>
          <span>
            {t("paragraph8a")} <span>{t("paragraph8b")}.</span>
          </span>
        </CalculatorBodyText>
      )}
    </>
  );
};

export default Result2;
